var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort flex-align"},[_c('div',{class:{
      'sort-item': true,
      'flex-align': true,
      active: _vm.srotActive === 1
    },on:{"click":function($event){return _vm.clickSort(1)}}},[_c('span',[_vm._v("推荐值")])]),_c('div',{class:{
      'sort-item': true,
      'flex-align': true,
      active: _vm.srotActive === 3
    },on:{"click":function($event){return _vm.clickSort(3)}}},[_c('span',[_vm._v("发布时间")]),_c('div',{staticClass:"sort-top-of-bottom flex-col"},[_c('i',{class:{
        'el-icon-caret-top': true,
        'el-icon-active': _vm.srotActive === 3 && _vm.sortType === 0
      }}),_c('i',{class:{
          'el-icon-caret-bottom': true,
          'el-icon-active': _vm.srotActive === 3 && _vm.sortType === 1
        }})])]),_c('div',{class:{
      'sort-item': true,
      'flex-align': true,
      active: _vm.srotActive === 2
    },on:{"click":function($event){return _vm.clickSort(2)}}},[_c('span',{staticClass:"flex-center"},[_vm._v("销量")]),_c('div',{staticClass:"sort-top-of-bottom flex-col"},[_c('i',{class:{
        'el-icon-caret-top': true,
        'el-icon-active': _vm.srotActive === 2 && _vm.sortType === 0
      }}),_c('i',{class:{
          'el-icon-caret-bottom': true,
          'el-icon-active': _vm.srotActive === 2 && _vm.sortType === 1
        }})])]),_c('div',{class:{
      'sort-item': true,
      'flex-align': true,
      active: _vm.srotActive === 4
    },on:{"click":function($event){return _vm.clickSort(4)}}},[_c('span',[_vm._v("利润")]),_c('div',{staticClass:"sort-top-of-bottom flex-col"},[_c('i',{class:{
        'el-icon-caret-top': true,
        'el-icon-active': _vm.srotActive === 4 && _vm.sortType === 0
      }}),_c('i',{class:{
          'el-icon-caret-bottom': true,
          'el-icon-active': _vm.srotActive === 4 && _vm.sortType === 1
        }})])])])}
var staticRenderFns = []

export { render, staticRenderFns }